import { useCallback, useState } from 'react';
import useEventBrokerSubscription from '../common/helpers/useEventBrokerSubscription';
import { processViewState } from './utils';

/**
 * What the Right Control Panel's controls should show (processViewState), re-read whenever
 * the display state changes -- however it was changed: a click, undo, a macro, a command.
 */
export default function useViewState() {
    const [, setChanges] = useState(0);
    // Stable across renders (a state setter is), so the subscription is made once.
    const handleViewStateChanged = useCallback(() => setChanges((n) => n + 1), []);
    useEventBrokerSubscription('viewStateChanged', handleViewStateChanged);

    return processViewState();
}
